import { createContext } from 'react'

type GlobalLoadingContextType = boolean

const GlobalLoadingContext = createContext<GlobalLoadingContextType>(false)

export default GlobalLoadingContext
